import { createSelector } from "reselect";

export default (...apiSelectors) =>
  createSelector(apiSelectors, (...apis) =>
    apis.reduce(
      (acc, { error }) =>
        error && error.non_field_errors
          ? {
              ...acc,
              nonField: [...acc.nonField, ...error.non_field_errors]
            }
          : error && typeof error === "object"
            ? {
                ...acc,
                field: { ...acc.field, ...error }
              }
            : acc,
      {
        nonField: [],
        field: {}
      }
    )
  );



// WEBPACK FOOTER //
// ./src/core/helpers/createErrorsSelector.js